var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 200C155.228 200 200 155.228 200 100C200 44.7715 155.228 0 100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M100 200C155.228 200 200 155.228 200 100C200 44.7715 155.228 0 100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200Z",
    fill: "#00C144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.839 183.662C147.508 183.662 185.34 145.83 185.34 99.161C185.34 52.4924 147.508 14.66 100.839 14.66C54.1703 14.66 16.3379 52.4924 16.3379 99.161C16.3379 145.83 54.1703 183.662 100.839 183.662Z",
    fill: "#00C144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8069 133.514H89.6969C88.1556 133.499 86.6323 133.18 85.2146 132.575C83.7969 131.97 82.5127 131.091 81.4359 129.988L58.5529 106.71C56.4881 104.47 55.3782 101.513 55.4592 98.4682C55.5403 95.423 56.8058 92.5294 58.9869 90.4027C61.1679 88.2759 64.0925 87.0837 67.1388 87.0795C70.1851 87.0752 73.113 88.2593 75.2999 90.38L89.9419 105.235L127.042 67.595C128.126 66.4729 129.424 65.579 130.859 64.9659C132.294 64.3528 133.837 64.033 135.397 64.0252C136.957 64.0174 138.504 64.3217 139.945 64.9204C141.386 65.5191 142.692 66.3999 143.788 67.5111C144.883 68.6223 145.745 69.9414 146.323 71.3907C146.901 72.8401 147.184 74.3904 147.154 75.9505C147.123 77.5106 146.782 79.0489 146.148 80.4749C145.515 81.9009 144.602 83.1858 143.465 84.254L97.9929 130.147C95.8134 132.299 92.8757 133.508 89.8129 133.514H89.8069Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.f29288945a9b1c2f63bb9cfc7d56afa2.svg";
export { ForwardRef as ReactComponent };